import { useCallback } from "react";

const STORAGE_KEY = "canmail_draft";

const isDraftEmpty = (fields) =>
  !fields.subject &&
  !fields.selectedTo &&
  !fields.replyTo &&
  !fields.emailBodyText &&
  !fields.emailBodyDropJson &&
  !fields.scheduledDate;

export function useEmailDraftCache() {
  const saveDraft = useCallback((fields) => {
    if (isDraftEmpty(fields)) {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // Ignore storage errors
      }
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(fields));
      console.log('[useEmailDraftCache] Draft saved', { subject: fields.subject, isDropEditor: fields.isDropEditor });
    } catch {
      // Quota exceeded or private browsing — silently skip
    }
  }, []);

  const loadDraft = useCallback(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const draft = JSON.parse(raw);
      console.log('[useEmailDraftCache] Draft loaded', { subject: draft.subject, isDropEditor: draft.isDropEditor });
      return draft;
    } catch {
      // Corrupted JSON — remove the bad key
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // Ignore
      }
      return null;
    }
  }, []);

  const clearDraft = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      console.log('[useEmailDraftCache] Draft cleared');
    } catch {
      // Ignore storage errors
    }
  }, []);

  return { saveDraft, loadDraft, clearDraft };
}
